import {DatePipe} from '@angular/common';
import {Component, computed, inject} from '@angular/core';
import {CommunicationCenterService} from '@modules/communication-center';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {FreemiumPremiumService} from 'shared/fremium-premium/freemium-premium.service';

@Component({
    selector: 'app-premium-state',
    imports: [
        TranslateModule,
    ],
    templateUrl: './premium-state.component.html',
    styleUrl: './premium-state.component.scss'
})
export class PremiumStateComponent {

    private FreemiumPremiumService = inject(FreemiumPremiumService);
    private translateService = inject(TranslateService);
    private communicationCenter = inject(CommunicationCenterService);

    protected expirationDate: Date | null = this.FreemiumPremiumService.expirationDate;
    protected isPremiumActive = computed(() => this.expirationDate !== null && new Date() < this.expirationDate);
    protected isLicenceExpired = computed(() => this.expirationDate !== null && new Date() >= this.expirationDate);
    protected localeDate = computed(() => {
        if (this.expirationDate) {
            return this.expirationDate?.toLocaleDateString(this.translateService.currentLang, {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });
        }
        return '';
    });

    protected expandPremiumClick($event: MouseEvent): void {
        this.communicationCenter
            .getRoom('freemium-premium')
            .getSubject('access-premium-display-compare-modal')
            .next(true);
    }
}
